/*
**
**
*Author: Ninad Kulkari
*Date: 25-9-2017
**
**
*/

import { Pipe, PipeTransform } from '@angular/core';
import { AppMetadataHandler } from '../../../configs/app-metadata.handler'

const PADDING = "00000000000000000000";

@Pipe({ name: 'CurrencyFormatter', pure: false })
export class CurrencyFormatterPipe implements PipeTransform {
    private PREFIX: string
    private DECIMAL_SEPARATOR: string;
    private THOUSANDS_SEPARATOR: string;
    private SUFFIX: string

    constructor(public appMetadataHandler: AppMetadataHandler) {
        this.PREFIX = this.appMetadataHandler.currencyOptions.prefix + ' '
        this.PREFIX = this.appMetadataHandler.currencyOptions.prefix + ' '
        this.DECIMAL_SEPARATOR = this.appMetadataHandler.currencyOptions.decimal + "";
        this.THOUSANDS_SEPARATOR = this.appMetadataHandler.currencyOptions.thousands + "";
    }

    transformUSCurrency(value: string, currencyCode?: string): string {
        let fractionSize: number = 2;
        let currencyPrefix = this.getCurrencyPrefix(currencyCode);
        let [integer, fraction = ""] = (value || "").toString()
            .split(".");

        fraction = fractionSize > 0
            ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";

        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (integer.trim() == "" || integer.trim() == null)
            return currencyPrefix + " " + "0,00" + this.SUFFIX;
        else
            return currencyPrefix + " " + integer + fraction + this.SUFFIX;
    }
    transform(value: string, fractionSize: number = 2, currencyCode?: string): string {
        let num = Number(value).toFixed(fractionSize);
        if (!!!currencyCode)
            currencyCode = this.getCurrencyCode();
        this.setCurrency(currencyCode);
        let [integer, fraction = ""] = num.toString()
            .split(".");

        fraction = fractionSize > 0
            ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";

        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

        if (integer.trim() == "" || integer.trim() == null)
            return this.PREFIX + "0,00";
        else
            return this.PREFIX + integer + fraction + this.SUFFIX;
    }

    getCurrencyCode() {
        let currency = null;
        currency = this.appMetadataHandler.policyCurrencyCd || this.appMetadataHandler.productCurrencyCd || this.appMetadataHandler.companyCurrencyCd || this.appMetadataHandler.currentCountryCdValue
        return currency;
    }

    getCurrencyPrefix(currencyCode) {
        let currencyObj = this.appMetadataHandler.supportedCurrencyMaster[currencyCode];
        if (currencyObj) {
            return currencyObj.baseCurrencyMiniPREFIX;
        }
        return "";
    }

    setCurrency(currencyCode) {
        let currencyObj = this.appMetadataHandler.supportedCurrencyMaster[currencyCode];
        if (currencyObj) {
            this.PREFIX = currencyObj.baseCurrencyPREFIX + ' '
            this.DECIMAL_SEPARATOR = currencyObj.DECIMAL_SEPARATOR + "";
            this.THOUSANDS_SEPARATOR = currencyObj.THOUSANDS_SEPARATOR + "";
            this.SUFFIX = currencyObj.baseCurrencySUFFIX + '';

            this.appMetadataHandler.baseCurrencyPREFIX = currencyObj.baseCurrencyPREFIX;
            this.appMetadataHandler.baseCurrencyMiniPREFIX = currencyObj.baseCurrencyMiniPREFIX
            this.appMetadataHandler.DECIMAL_SEPARATOR = currencyObj.DECIMAL_SEPARATOR
            this.appMetadataHandler.THOUSANDS_SEPARATOR = currencyObj.THOUSANDS_SEPARATOR
            this.appMetadataHandler.baseCurrencySUFFIX = currencyObj.baseCurrencySUFFIX
        }
    }

    parse(value: string, fractionSize: number = 2): string {
        let [integer, fraction = ""] = (value || "").replace(this.PREFIX, "")
            .replace(this.SUFFIX, "")
            .split(this.DECIMAL_SEPARATOR);

        integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

        fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
            ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";

        return integer + fraction;
    }
}